import type { IconProps } from '../types/IconProps.ts';
export const ExternalLink: IconProps = {
    name: 'ExternalLink',
    children: [
        `<path d="M18 13v7.58c0 .23-.19.42-.42.42H3.42a.4.4 0 0 1-.42-.42V6.42c0-.23.19-.42.42-.42H11M15 3h5.5c.28 0 .5.22.5.5V9M10 14 20 4" />`,
    ]
};